// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3TdRw","label":"SetPasswdForm_label__g-8Ss"};